import { useAuth } from '@/hooks/useAuth';
import AgentDashboard from '@/components/dashboard/AgentDashboard';
import AdminDashboard from '@/components/dashboard/AdminDashboard';
import ContentManagerDashboard from '@/components/dashboard/ContentManagerDashboard';

const HomePage = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-500">Cargando...</div>
      </div>
    );
  }

  const renderDashboardByRole = () => {
    switch (user.roleCode) {
      case 'agent':
      case 'superagent':
        return <AgentDashboard />;
      case 'admin':
      case 'superadmin':
        return <AdminDashboard />;
      case 'contentManager':
        return <ContentManagerDashboard />;
      default:
        return (
          <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-3xl font-bold text-gray-900 mb-8">Bienvenido</h1>
              <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Panel no disponible</h2>
                <p className="text-gray-600">
                  No hay un panel específico configurado para tu rol: <strong>{user.roleName}</strong>
                </p>
              </div>
            </div>
          </div>
        );
    }
  };

  return renderDashboardByRole();
};

export default HomePage;
